import { useState } from "react";
import * as S from "./style";
//Components
import Camera from "../../../../../components/Modals/Camera";
import ActionButton from "../../../../Button/ActionButton";
import Details from "../Discount";
//hooks
import useLoading from "../../../../../hooks/useLoading";
import { useMultipleModal } from "../../../../../hooks/useMultipleModal";
//Utils
import { CurrencyFormat, formatPercentage } from "utils/CurrencyFormat";
import { CalcAmountAndValue } from "utils/FunctionOrder";
import TruncateText from "utils/TruncateText";
//Interface
import { ICustomer } from "Interfaces/ICustomer";
import { IFrame } from "Interfaces/IFrame";
import { ILens } from "Interfaces/ILens";
import { IService } from "Interfaces/IService";
import { IData } from "Interfaces/ITableOrder";
//Icons
import { Barcode, Info, MagnifyingGlass, SealPercent, Trash } from "@phosphor-icons/react";
import ReactLoading from "react-loading";
import axiosInstance from "services/axiosInstance";

interface IForms {
  setSelectedTable: React.Dispatch<React.SetStateAction<IFrame[]>>;
  setSelectedCustomer: (id: number) => void;
  setNameCustomer: (name: string) => void;
  totalOrderTable: (total: number) => void;
  errors: any;
  register: any;
}

export default function FormsOrder({
  setSelectedTable,
  setSelectedCustomer,
  setNameCustomer,
  totalOrderTable,
  errors,
  register,
}: IForms) {
  const {
    isLoading: isLoadingSearch,
    startLoading: startLodSearch,
    stopLoading: stopLodSearch,
  } = useLoading();

  const {
    isLoading: isLoadingSearchCustom,
    startLoading: startLodSearchCustom,
    stopLoading: stopLodSearchCustom,
  } = useLoading();

  const listHeadTable = [
    "N°",
    "Produto",
    "Tipo",
    "Qtd.",
    "Valor Unit.",
    "Pagamento",
    "Desconto",
    "Subtotal",
    "Ações",
  ];
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const [frame, setFrame] = useState<(IFrame & IService & ILens)[]>([]);
  const [customer, setCustomer] = useState<ICustomer[]>([]);

  //Adicionar Produtos na tabela
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProducts, setSelectedProducts] = useState<IData[]>([]);
  const [buttonAddProduct, setButtonAddProduct] = useState<IFrame | null>(null);
  const [quantity, setQuantity] = useState<number>(1);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [totalValue, setTotalValue] = useState('');
  // Estado para controlar o item em edição
  const [itemEdit, setItemEdit] = useState<null | {
    id: number;
    index: number;
    price: string;
    type: string
  }>(null);

  const [idProduct, setIdProduct] = useState<number | null>(null);

  //Adcionando Cliente
  const [searchCustom, setSearchCustom] = useState("");

  const fetchData = async (url: string) => {
    try {
      if (url === "sale" && searchTerm) {
        startLodSearch();
        if (searchTerm) {
          const response = await axiosInstance.get(`/sale-search-stock?&search=${searchTerm}`);
          const {
            frames = [],
            lenses = [],
            services = []
          } = response.data;

          // Verificar se há resultados
          const combinedResults = [
            ...frames.map((item: IFrame) => ({ ...item, type: 'frame' })),
            ...lenses.map((item: ILens) => ({ ...item, type: 'lens' })),
            ...services.map((item: IService) => ({ ...item, type: 'service' }))
          ];

          if (combinedResults.length > 0) {
            setFrame(combinedResults); // Atualiza o estado com os resultados combinados
          } else {
            setFrame([]); // Nenhum resultado encontrado
          }
        }

      } else if (url === "customer" && searchCustom) {
        startLodSearchCustom();
        if (searchCustom) {
          const response = await axiosInstance.get(
            `/customer?&search=${searchCustom}`
          );
          const length = response.data.data.length;
          if (length > 0) {
            setCustomer(response.data.data);
          } else {
            setCustomer([]);
          }
        }
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLodSearch();
      stopLodSearchCustom();
    }
  };

  //Capturar valor digitado na pesquisa
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value === "") {
      setSearchTerm("");
      toggleModalVisibility("menu");
    }
  };

  const handleInputChangeCustomer = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    setSearchCustom(value);
    if (value === "") {
      setSearchCustom("");
      toggleModalVisibility("customerMenu");
    }
  };

  //Pesquisar Cliente ou Produto
  const handleSearchChange = async (typeUrl: string) => {
    await fetchData(typeUrl);
    if (typeUrl === "customer") {
      toggleModalVisibility("customerMenu");
      return;
    } else if (typeUrl === "sale") {
      toggleModalVisibility("menu");
    }
  };

  // Adicionando produtos no input (Lente, armação e serviço)
  const handleCampClick = (product: (IFrame & IService & ILens)) => {
    setButtonAddProduct(product);
    setSearchTerm(product.code || product.name || product.name_lens);
    toggleModalVisibility("menu");
  };

  //Clicando e Adicionando Produto e quantidade na tabela
  const handleLaunchClick = () => {
    if (buttonAddProduct && quantity > 0) {
      const productWithQuantity = {
        ...buttonAddProduct,
        amount: quantity,
        form_payment: '-',
        discount: '0',
      };

      setSelectedProducts((prevSelectedProducts: any) => [
        ...prevSelectedProducts,
        productWithQuantity,
      ]);

      setButtonAddProduct(null);
      setQuantity(1);
      setSearchTerm(""); // Limpa o campo de pesquisa

      setSelectedTable((prevSelectedProducts) => [
        ...prevSelectedProducts,
        productWithQuantity,
      ]);
    }
  };

  //Deletando produto da tabela
  const handleDeleteProduct = (index: number) => {
    setSelectedProducts((prevSelectedProducts) =>
      prevSelectedProducts.filter((_, i) => i !== index)
    );

    setSelectedTable((prevSelectedProducts) =>
      prevSelectedProducts.filter((_, i) => i !== index)
    );
  };

  /// Função para abrir o modal de edição
  const handleEditClick = (
    id: number,
    index: number,
    price: string,
    qtd: number,
    type: string
  ) => {
    const value = (Number(price) * qtd).toString();
    setTotalValue(value);
    setItemEdit({
      id,
      index,
      price,
      type
    });
    setIdProduct(id);
    toggleModalVisibility("details-payment");
  };

  // Função para editar o produto
  const editarProduto = (novoProduto: any) => {
    if (!itemEdit) return;
    setSelectedProducts((prevSelectedProducts: any) =>
      prevSelectedProducts.map((produto: any, i: number) =>
        i === itemEdit.index
          ? {
            ...produto,
            promotion_id: novoProduto.promotion_id,
            paymentable_type: novoProduto.paymentable_type,
            paymentable_id: novoProduto.paymentable_id,
            namePayment: novoProduto.name_payment,
            discount: novoProduto.discount,
            user_id: novoProduto.user_id,
            installment_credit: novoProduto.installment_credit
          }
          : produto
      )
    );

    setSelectedTable((prevSelectedProducts: any) =>
      prevSelectedProducts.map((produto: any, i: number) =>
        i === itemEdit.index
          ? {
            ...produto,
            promotion_id: novoProduto.promotion_id,
            paymentable_type: novoProduto.paymentable_type,
            paymentable_id: novoProduto.paymentable_id,
            namePayment: novoProduto.name_payment,
            installment_credit: novoProduto.installment_credit,
            discount: novoProduto.discount,
            // Atualizando o valor total com o desconto
            price: calculateDiscountedPrice(itemEdit.price, novoProduto.discount),
            user_id: novoProduto.user_id
          }
          : produto)
    )
  };

  // Função auxiliar para calcular o preço com desconto
  const calculateDiscountedPrice = (price: string, discount: number) => {
    const valor = Number(price) || 0;
    return (valor - (valor * Number(discount || 0) / 100)).toString();
  };

  //Modal do detalhes sobre o produto na tabela
  const handleDetails = (index: number) => {
    setSelectedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  //Adicionando Cliente no input
  const handleCampClickCustomer = (paciente: ICustomer) => {
    setSearchCustom(`${paciente.full_name} ${paciente.cpf || ""}`);
    setSelectedCustomer(paciente.id);
    setNameCustomer(paciente.full_name);
    toggleModalVisibility("customerMenu");
  };

  /**
   * Calcula o total dos produtos selecionados somando o valor de...
   * ...cada produto no array `selectedProducts`.
   *
   * @returns {number} - O valor total somado de todos os produtos selecionados.
   */
  const calculateTotal = () => {
    const total = selectedProducts.reduce((total, product) => {

      // Calcular o total de cada produto, incluindo o desconto
      const totalProduct = product.amount * Number(product.price);
      const discount = totalProduct * Number(product.discount) / 100 || 0;

      const totalWithDiscount = totalProduct - discount;
      const result = total + totalWithDiscount;

      return result;
    }, 0);
    totalOrderTable(total);
    return CurrencyFormat(total); // Retorna o valor total com o formato de moeda
  };

  const handleScanResult = (result: string | null) => {
    if (result) {
      setSearchTerm(result);
      toggleModalVisibility("scanner"); // Fechar modal após escanear
    }
  };

  return (
    <S.Forms>
      <S.SeparateDiv>
        <S.SeparateDiv>
          <S.ContentPopMenu>
            <S.FormInput>
              <S.Label>Buscar Produto</S.Label>
              <S.ContentInput>
                <S.InputNoStyle
                  placeholder="Informe o código da armação, nome do serviço ou acessório"
                  type="text"
                  id="product"
                  autoComplete="off"
                  onChange={handleInputChange}
                  value={searchTerm}
                />

                <S.ContentButton>
                  {/* //Scannear */}
                  <S.ButtonIconTable onClick={() => toggleModalVisibility('scanner')}>
                    <Barcode size={20} />
                  </S.ButtonIconTable>

                  {/* //Pesquisar */}
                  <S.ButtonIconTable
                    onClick={() => handleSearchChange("sale")}>
                    {isLoadingSearch ? (
                      <ReactLoading
                        type="spokes"
                        color="red"
                        height="20px"
                        width="20px"
                      />
                    ) : (
                      <MagnifyingGlass size={20} />
                    )}
                  </S.ButtonIconTable>
                </S.ContentButton>
              </S.ContentInput>
            </S.FormInput>

            {isOpenModal("menu") && (
              <S.PopMenu ref={(ref) => assignRef("menu", ref)}>
                {frame.length > 0 ? (
                  frame.map(function (val) {
                    return (
                      <S.ButtonMenu onClick={() => handleCampClick(val)}>
                        {val.code || val.name || val.name_lens} - {CurrencyFormat(parseFloat(val.price || '0'))} - {val.amount || 0}qtd.
                      </S.ButtonMenu>
                    );
                  })
                ) : (
                  <span>Nenhum dado encontrado</span>
                )}
              </S.PopMenu>
            )}
          </S.ContentPopMenu>

          <S.FormInputSmall>
            <S.Label>Quantidade</S.Label>
            <S.Input
              placeholder="0001"
              type="number"
              onChange={(e) => setQuantity(Number(e.target.value))}
              value={quantity}
            />
          </S.FormInputSmall>
        </S.SeparateDiv>

        {/* //Adicionar */}
        <S.ContentButton>
          <ActionButton
            name="Adicionar Produto"
            onClick={handleLaunchClick} />
        </S.ContentButton>
      </S.SeparateDiv>

      {/* table */}
      <S.ContainerTable>
        <S.Table>
          <S.Thead>
            <tr>
              {listHeadTable.map((header) => {
                return <th>{header}</th>;
              })}
            </tr>
          </S.Thead>

          <S.Tbody>
            {selectedProducts.map((val, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    {TruncateText(String(val.code || val.name || val.name_lens), 12)}
                    <S.Button onClick={() => handleDetails(index)}>
                      <Info size={16} />
                    </S.Button>

                    {selectedIndex === index && (
                      <S.DetalhesProduct>
                        {val.type === "frame" ? (
                          <p>
                            {`A armação ${val.code} possui tamanho ${val.size}, haste de ${val.haste}mm, ponte de ${val.bridge}mm, cor ${val.color}, e está disponível pelo preço de ${CurrencyFormat(parseFloat(val.price || '0'))}. O desconto aplicado pela grife é de ${val.brands?.discount || 0}%.`}
                          </p>
                        )
                          : val.type === "service" ? (
                            <p>
                              {`O serviço ${val.name} custa ${CurrencyFormat(parseFloat(val.price || '0'))}. Detalhes adicionais: ${val.description}.`}
                            </p>
                          ) : val.type === "lens" ? (
                            <p>
                              {`A lente ${val.name_lens} custa ${CurrencyFormat(parseFloat(val.price || '0'))}. Tipo da lente: ${val.type_lens?.type_lens || '-'}, Índice: ${val.index || '-'}, Antirreflexo: ${val.treatment?.treatment || '-'}, Esferico: ${val.spherical}, Cilindro: ${val.cylindrical}, Foco Sensibilidade: ${val.sensitivity?.sensitivity || '-'}(${val.sensitivity?.percentage || '-'}%). ${val.filter ? 'Com Filtro Azul.' : 'Sem Filtro Azul.'}`}
                            </p>
                          )
                            : (
                              "Tipo de produto não reconhecido."
                            )}
                      </S.DetalhesProduct>
                    )}
                  </td>
                  <td>{val.type === "frame" ? 'Armação' : val.type === "service" ? 'Serviço' : 'Lente'}</td>
                  <td>{val.amount}</td>
                  <td>{CurrencyFormat(parseFloat(val.price))}</td>
                  <td>{val.namePayment || '-'} {val.installment_credit ? `(${val.installment_credit}x)` : ''}</td>
                  <td>{formatPercentage(parseFloat(val.discount || '0'))}</td>
                  <td>{CalcAmountAndValue(Number(val.price), val.amount, Number(val.discount))}</td>
                  <td>
                    <div>
                      <S.ButtonIconTable
                        onClick={() => handleEditClick(
                          val.id,
                          index,
                          val.price,
                          val.amount,
                          val.type)}
                      >
                        <SealPercent size={20} color="black" />
                      </S.ButtonIconTable>

                      <S.ButtonIconTable
                        onClick={() => handleDeleteProduct(index)}
                      >
                        <Trash size={20} />
                      </S.ButtonIconTable>
                    </div>
                  </td>
                </tr>
              );
            })}
          </S.Tbody>
        </S.Table>
        <S.TotalValue>Total {calculateTotal()}</S.TotalValue>
      </S.ContainerTable>
      {/* fim table */}

      {/* //Pesquisa */}
      <S.ContentPopMenu>
        <S.FormInput>
          <S.Label>
            Cliente <span>*</span>
          </S.Label>
          <S.ContentInput>
            <S.InputNoStyle
              placeholder="Informe o nome do Cliente"
              type="text"
              id="customer"
              autoComplete="off"
              value={searchCustom}
              onChange={handleInputChangeCustomer}
            />
            <S.ButtonIconTable onClick={() => handleSearchChange("customer")}>
              {isLoadingSearchCustom ? (
                <ReactLoading
                  type="spokes"
                  color="red"
                  height="20px"
                  width="20px"
                />
              ) : (
                <MagnifyingGlass size={20} />
              )}
            </S.ButtonIconTable>
          </S.ContentInput>
        </S.FormInput>

        {isOpenModal("customerMenu") && (
          <S.PopMenu>
            {customer.length > 0 ? (
              customer.map(function (val) {
                return (
                  <S.ButtonMenu onClick={() => handleCampClickCustomer(val)}>
                    {val.full_name} {val.cpf || ""}
                  </S.ButtonMenu>
                );
              })
            ) : (
              <span>Nenhum dado encontrado</span>
            )}
          </S.PopMenu>
        )}
      </S.ContentPopMenu>

      <S.FormInput>
        <S.Label>
          Número da Venda
          <span>*</span>
        </S.Label>
        <S.Input
          {...register("number_ata", { required: true })}
          placeholder="Informe o número da venda"
          type="text"
          autoComplete="off"
        />
        {errors.number_ata && <S.InforErro>Campo Obrigatório</S.InforErro>}
      </S.FormInput>

      {/* Modal para abrir a câmera */}
      {isOpenModal('scanner') && (
        <Camera
          isOpenModalCamera={isOpenModal("scanner")}
          setModalClose={() => toggleModalVisibility("scanner")}
          onScanResult={handleScanResult}
        />
      )}

      <Details
        isOpenModalDetails={isOpenModal("details-payment")}
        setModalClose={() => toggleModalVisibility("details-payment")}
        totalProduct={totalValue}
        dataPayment={(novoProduto: any) => editarProduto(novoProduto)}
        idProduct={idProduct}
        typeUrl={itemEdit?.type || ''}
      />
    </S.Forms>
  );
}
